module.exports = __webpack_public_path__ + "roboto-latin-900-normal.2e8becfcae330421664b6806b872080f.hashedasset.woff2";